import React from 'react';

const STORIES = [
  { tag: 'Trend Report', title: 'The Quiet Luxury Manifesto', excerpt: 'Why whispered wealth has dethroned the loud logo era and what to invest in now.', img: 'https://images.pexels.com/photos/9514677/pexels-photo-9514677.jpeg' },
  { tag: 'Sustainability', title: 'A Second Life for Couture', excerpt: 'The circular economy is rewriting what it means to consume luxury.', img: 'https://images.pexels.com/photos/28251082/pexels-photo-28251082.jpeg' },
  { tag: 'Designer Spotlight', title: 'Inside the Hermès Atelier', excerpt: 'A glimpse at the craftsmanship behind the world\'s most desirable handbag.', img: 'https://images.pexels.com/photos/135620/pexels-photo-135620.jpeg' },
  { tag: 'Investment Guide', title: 'Watches That Hold Their Value', excerpt: 'The horological investments that consistently appreciate.', img: 'https://images.pexels.com/photos/380782/pexels-photo-380782.jpeg' },
  { tag: 'Heritage', title: 'A History of the Cabochon', excerpt: 'From ancient Egypt to Cartier — the gem cut that defined an era.', img: 'https://images.pexels.com/photos/4974506/pexels-photo-4974506.jpeg' },
  { tag: 'How To', title: 'Authenticating a Birkin', excerpt: 'Our gemologists reveal the subtle details that separate genuine from counterfeit.', img: 'https://images.pexels.com/photos/14806252/pexels-photo-14806252.jpeg' },
];

export default function Editorial() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16" data-testid="editorial-page">
      <span className="overline text-accent">The Edit</span>
      <h1 className="font-display text-5xl sm:text-7xl mt-3 tracking-tight max-w-3xl">Stories from the world of authenticated luxury.</h1>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
        {STORIES.map((s, i) => (
          <article key={i} className="group" data-testid={`story-${i}`}>
            <div className="aspect-[4/5] bg-muted overflow-hidden">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover ken-burns" />
            </div>
            <div className="mt-6">
              <span className="overline text-muted-foreground">{s.tag}</span>
              <h2 className="font-display text-2xl mt-2 leading-tight">{s.title}</h2>
              <p className="mt-3 text-sm font-light text-muted-foreground line-clamp-3">{s.excerpt}</p>
              <span className="mt-4 inline-block overline link-underline">Read →</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
